import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { BtnPrimary } from "@/components/Buttons";
import { VALUES, IMAGES } from "@/lib/data";

export default function Sobre() {
  return (
    <>
      <section className="relative overflow-hidden pt-36 md:pt-44">
        <div className="pointer-events-none absolute right-[-10%] top-8 h-[420px] w-[420px] rounded-full bg-grad opacity-[0.12] blur-[130px]" />
        <div className="mx-auto max-w-[1440px] px-6 pb-16 md:px-12">
          <Reveal>
            <span className="text-xs font-medium uppercase tracking-[0.28em] text-grad">O nosso objetivo</span>
            <h1 className="mt-5 max-w-5xl font-display text-5xl font-extrabold leading-[0.98] tracking-tight text-ink sm:text-6xl lg:text-[5.2rem] text-balance">
              Não perca clientes por não ter <span className="text-grad">presença online</span>
            </h1>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-[1440px] px-6 md:px-12">
        <div className="grid gap-10 md:grid-cols-[1.05fr_0.95fr] md:gap-16">
          <Reveal>
            <div className="overflow-hidden rounded-[1.6rem] border border-line">
              <img src={IMAGES.workspace} alt="Espaço de trabalho da Get Visible com portátil e tablet" loading="lazy" className="aspect-[4/3] w-full object-cover" />
            </div>
          </Reveal>
          <Reveal delay={1} className="flex flex-col justify-center gap-6">
            <h2 className="font-display text-3xl font-semibold leading-tight text-ink md:text-4xl">Estando offline, os seus concorrentes ganham.</h2>
            <p className="text-lg leading-relaxed text-muted-foreground">
              Hoje, a primeira impressão acontece online. Atualmente, a maioria dos clientes procura uma empresa na Internet antes de tomar uma decisão. Se não encontrar um website profissional ou uma presença digital credível, é muito provável que escolha outra opção.
            </p>
            <p className="text-lg leading-relaxed text-muted-foreground">
              O nosso objetivo é simples: ajudar pequenas empresas, negócios locais e marcas a terem uma presença online moderna, profissional e capaz de gerar confiança desde o primeiro contacto.
            </p>
            <p className="text-lg leading-relaxed text-muted-foreground">
              Criamos websites personalizados, rápidos e totalmente adaptados ao seu negócio, com um processo simples, acompanhamento próximo e um investimento acessível. Enquanto se dedica ao que faz melhor, nós tratamos da sua presença digital.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-[1440px] px-6 py-24 md:px-12 md:py-32">
        <Reveal className="mb-12 max-w-2xl">
          <span className="text-xs font-medium uppercase tracking-[0.25em] text-grad">O que nos guia</span>
          <h2 className="mt-4 font-display text-4xl font-semibold tracking-tight text-ink sm:text-5xl">Aquilo em que acreditamos</h2>
        </Reveal>
        <div className="grid gap-6 md:grid-cols-3">
          {VALUES.map((v, i) => {
            const Icon = v.icon;
            return (
              <motion.div
                key={v.title}
                initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }} transition={{ duration: 0.6, delay: i * 0.08 }}
                className="rounded-2xl border border-line bg-tint p-8"
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-grad text-white"><Icon className="h-5 w-5" strokeWidth={1.6} /></span>
                <h3 className="mt-6 font-display text-xl font-semibold text-ink">{v.title}</h3>
                <p className="mt-3 leading-relaxed text-muted-foreground">{v.body}</p>
              </motion.div>
            );
          })}
        </div>

        <div className="mt-16 flex flex-col items-start gap-6 rounded-[2rem] bg-ink p-10 text-white md:flex-row md:items-center md:justify-between md:p-14">
          <h3 className="max-w-lg font-display text-3xl font-semibold md:text-4xl">Pronto para dar visibilidade ao seu negócio?</h3>
          <BtnPrimary to="/contacto">Fale connosco</BtnPrimary>
        </div>
      </section>
    </>
  );
}
